import React from 'react'

export default ({ children, before }) => (
  <div className="form-container">
    {before && <div className="form-container__before">{before}</div>}
    <div className="form-container__inner">{children}</div>
  </div>
)
